module.exports = __webpack_public_path__ + "assets/img/mecha-btn-78ea2851.png";